import { ConnectionCard } from '../ConnectionCard'
import { sx } from '../../../lib/sx'
import { Hov } from '../../../lib/Hov'
import type { Vals } from '../../../demo/vals'

export function Connect({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;padding-top:64px;display:flex;flex-direction:column")}>
      <div style={sx("padding:0 20px 22px;display:flex;align-items:center;justify-content:space-between;gap:12px")}>
        <span style={sx("font-size:var(--fs-5xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm)")}>
          Connect
        </span>
      </div>
      <div style={sx("flex:1;min-height:0;overflow:auto;padding:0 20px 16px;display:flex;flex-direction:column;gap:14px")}>
        <ConnectionCard server="Lithuania #218" />
        {v.showConnectPromo ? (
        <Hov as="button" onClick={v.openGroupUpsell} style={sx("width:100%;text-align:left;padding:16px;border-radius:var(--radius-lg);border:1px solid var(--border-accent);background:var(--bg-accent-subtle);color:var(--text-primary);font-family:inherit;cursor:pointer;display:flex;align-items:center;gap:12px")} hoverStyle={sx("border-color:var(--bg-accent)")}>
          <span style={sx("width:40px;height:40px;flex:none;border-radius:var(--radius-full);background:var(--bg-accent);display:flex;align-items:center;justify-content:center")}>
            <span style={sx("width:20px;height:20px;background:#fff;-webkit-mask:url(/assets/icons/refer.svg) center/contain no-repeat;mask:url(/assets/icons/refer.svg) center/contain no-repeat")} />
          </span>
          <span style={sx("flex:1;display:flex;flex-direction:column;gap:3px;min-width:0")}>
            <span style={sx("font-size:var(--fs-sm);font-weight:var(--fw-medium);line-height:19px")}>
              Protect your close ones with NordVPN Group account
            </span>
            <span style={sx("font-size:var(--fs-xs);color:var(--text-secondary)")}>
              {v.connectPromoSub}
            </span>
          </span>
          <span style={sx("width:16px;height:16px;flex:none;opacity:.6;background:var(--text-primary);-webkit-mask:url(/assets/icons/arrow-right.svg) center/contain no-repeat;mask:url(/assets/icons/arrow-right.svg) center/contain no-repeat")} />
        </Hov>
        ) : null}
      </div>
      <div style={sx("height:82px;flex:none;border-top:1px solid var(--border-secondary);background:var(--bg-secondary);display:flex;align-items:flex-start;padding:12px 8px 0")}>
        <button onClick={v.mTabConnect} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-accent);-webkit-mask:url(/assets/icons/nav-globe.svg) center/contain no-repeat;mask:url(/assets/icons/nav-globe.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-accent);font-weight:var(--fw-medium)")}>
            Connect
          </span>
        </button>
        <button onClick={v.mTabProtect} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat;mask:url(/assets/icons/nav-threat.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
            Protect
          </span>
        </button>
        <button onClick={v.mTabMonitor} style={sx("flex:1;background:none;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:5px;font-family:inherit")}>
          <span style={sx("width:24px;height:24px;background:var(--text-secondary);-webkit-mask:url(/assets/icons/security-score.svg) center/contain no-repeat;mask:url(/assets/icons/security-score.svg) center/contain no-repeat")} />
          <span style={sx("font-size:var(--fs-2xs);color:var(--text-secondary)")}>
            Monitor
          </span>
        </button>
      </div>
    </div>
  )
}
